var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer pt-5 pb-5"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-subtitle-1",
    domProps: {
      "textContent": _vm._s('OUR COMPANY')
    }
  })]), _c('div', {
    staticClass: "footer-links"
  }, [_c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.com/pages/career"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            Career\n          ")]), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.com/pages/membership-overview"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            Membership\n          ")]), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.com/pages/about"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            About-us\n          ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-subtitle-1",
    domProps: {
      "textContent": _vm._s('CUSTOMER SERVICE')
    }
  })]), _c('div', {
    staticClass: "footer-links"
  }, [_c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.com/pages/contact"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            Contact us\n          ")]), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.helpscoutdocs.com/"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            Frequently Asked\n          ")]), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.com/policies/privacy-policy"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            Privacy Policy\n          ")]), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://routeline.com/policies/terms-of-service"
    }
  }, [_c('div', {
    staticClass: "link-bullet"
  }), _vm._v("\n            Terms of Service\n          ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-subtitle-1",
    domProps: {
      "textContent": _vm._s('SIGN UP AND SAVE')
    }
  })]), _c('div', {
    staticClass: "text-subtitle-1 mb-4",
    domProps: {
      "textContent": _vm._s('Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.')
    }
  }), _c('div', {
    staticClass: "footer-links"
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "text-h6 mb-4"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": require("@/assets/logo.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "footer-links d-flex"
  }, [_c('a', {
    staticClass: "footer-link mr-2",
    attrs: {
      "href": "https://business.facebook.com/RouteLineCo"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _c('a', {
    staticClass: "footer-link mr-2",
    attrs: {
      "href": "https://www.instagram.com/routelineco"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _c('a', {
    staticClass: "footer-link mr-2",
    attrs: {
      "href": "https://www.tiktok.com/@routelineco"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "src": require("@/assets/tiktok.svg"),
      "alt": ""
    }
  })]), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "https://www.youtube.com/channel/UCCoVUtIsuleNBtfCxnHvkWw"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }